import { Injectable } from '@angular/core';
import { BaseService, LeagueApi, LeagueDocument } from '@mtgame/core';
import { LeagueRootService } from '@core/services/league-root.service';
import { Observable } from 'rxjs';

const STORE_DOCUMENTS_KEY = 'documents';


@Injectable({providedIn: 'root'})
export class LeagueDocumentsService extends BaseService {
  private leagueId: number;

  get documents$(): Observable<LeagueDocument[]> {
    return this.store.get(STORE_DOCUMENTS_KEY);
  }

  constructor(
    private leagueApi: LeagueApi,
    private leagueRootService: LeagueRootService,
  ) {
    super();
  }

  async initialize(): Promise<LeagueDocument[]> {
    const league = this.leagueRootService.getLeagueModel();
    this.leagueId = league.id;
    return await this.getDocuments();
  }

  async getDocuments(): Promise<LeagueDocument[]> {
    const documents = await this.leagueApi.getDocuments(this.leagueId);
    this.store.save(STORE_DOCUMENTS_KEY, documents);
    return documents;
  }
}
